<div class="compare-root">

    <!-- TOOLBAR -->
    <div class="toolbar">
        <p-selectButton 
            [options]="[
                {label:'Überblenden', value:'blend'},
                {label:'Slider', value:'slider'},
                {label:'Differenz', value:'diff'}
            ]"
            [(ngModel)]="mode">
        </p-selectButton>

        @if (mode === 'blend' || mode === 'slider') {
            <p-slider class="width300" [(ngModel)]="slider" [min]="0" [max]="100"></p-slider>
        }
        
        @if (mode === 'blend') {
            <p-selectButton 
                [options]="[
                    {label:'Links aktiv', value:'left'},
                    {label:'Rechts aktiv', value:'right'}
                ]"
                [(ngModel)]="activeLayer">
            </p-selectButton>
        }
    </div>

    <!-- CLIENT AREA -->
    <div class="viewer">

        <!-- BLEND -->
        @if (mode === 'blend') {
            @if (activeLayer == "right") {
                <div class="layer base">
                    <ng-container *ngTemplateOutlet="rightTpl"></ng-container>
                </div>

                <div class="layer overlay" [style.opacity]="opacity">
                    <ng-container *ngTemplateOutlet="leftTpl"></ng-container>
                </div>  
            }
            @else {
                <div class="layer base">
                    <ng-container *ngTemplateOutlet="leftTpl"></ng-container>
                </div>

                <div class="layer overlay" [style.opacity]="opacity">
                    <ng-container *ngTemplateOutlet="rightTpl"></ng-container>
                </div>
            }            
        }

        <!-- SLIDER -->
        @if (mode === 'slider') {
            <div class="layer base">
                <ng-container *ngTemplateOutlet="leftTpl"></ng-container>
            </div>

            <div class="layer overlay" [style.clip-path]="clipPathRight">
                <ng-container *ngTemplateOutlet="rightTpl"></ng-container>
            </div>

            <div class="divider" [style.left.%]="slider"></div>
        }

        <!-- DIFFERENCE -->
        @if (mode === 'diff') {
            <div class="layer base">
                <ng-container *ngTemplateOutlet="leftTpl"></ng-container>
            </div>

            <div class="layer overlay diff">
                <ng-container *ngTemplateOutlet="rightTpl"></ng-container>
            </div>
        }

    </div>
</div>